import React from 'react';
import ReactDOM from 'react-dom';
import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"
import axios from 'axios'

import { default_en } from './i18n/en.js'
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

let langs = {}

function initi18n() {
	i18n
		.use(LanguageDetector)
		.use(initReactI18next)
		.init({
			resources: {},
			fallbackLng: "en",
			debug: true,
			ns: ["translations"],
			defaultNS: "translations",
			keySeparator: false,
			interpolation: {
				escapeValue: false
			},
			react: {
				useSuspense: false
			}
		}).then(() => {
			let setEN = false
			if (langs && Object.keys(langs).length > 0) {
				Object.keys(langs).forEach(key => {
					if (key === 'en')
						setEN = true

					i18n.addResourceBundle(key, 'translations', langs[key])
				})
			}

			if (!setEN)
				i18n.addResourceBundle('en', 'translations', default_en)

			ReactDOM.render(
				<App />,
				document.getElementById('root')
			);
		}).catch((err) => {
			console.log('errr', err)
		})
}

if (process.env.REACT_APP_LOGIN_LANGUAGES) {
	async function downloadLanguages() {
		for (const language of process.env.REACT_APP_LOGIN_LANGUAGES.split(',')) {
			//const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/v1/languages/${language}/downloadtransalation`)
			const res = await axios.get(`/locales/${language}/lang.json`)
			langs[language] = res.data
		}
		initi18n()
	}
	downloadLanguages()
} else {
	initi18n()
}

reportWebVitals();
